import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-default-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './default-sidebar.component.html',
  styleUrl: './default-sidebar.component.scss'
})
export class DefaultSidebarComponent implements OnInit{
   // Track open items by path or index
  activePaths: string[] = [];
  activeRoute:string = '/configurationSetting';

  toggleItem(path: string) {
    if (this.activePaths.includes(path)) {
      this.activePaths = this.activePaths.filter(p => p !== path);
    } else {
      this.activePaths.push(path);
    }
  }
  isActive(path: string): boolean {
    return this.activePaths.includes(path);
  }

  constructor(private router:Router){
    this.router.events
    .pipe(filter(e => e instanceof NavigationEnd))
    .subscribe((e: any) => {
      // Auto open the path based on route if needed
      const segments = e.urlAfterRedirects.split('/');
      this.activePaths = segments; // or a transformation of it
      this.activeRoute = this.activePaths[1];

    });
  }

  ngOnInit(): void {
   
  }

  goToPage(route:string){
    this.activeRoute = route;
    this.router.navigateByUrl(route)
  }

}